import type { FC } from 'react'

import { Translation } from '@/components/i18n/Translation'
import { numberFormat } from '@/util/formatters/numbers'

import './hits.scss'

const Hits: FC<{ amount: number }> = ({ amount }) => (
  <div className="hits">
    <Translation id="Hits: {hits}" hits={numberFormat(amount)} />
  </div>
)

export default Hits
